import { z } from 'zod'
import { MemberSchema } from './member.js'

export const CurrentUserSchema = z.object({
  id: z.string().min(1),
  display_name: z.string().min(1),
})
export type CurrentUser = z.infer<typeof CurrentUserSchema>

export const FamilySchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  members: z.array(MemberSchema),
  // The logged-in user attached to this session. `null` when the session row
  // points at a missing/deleted user — additive field, frontends predating
  // this change still read `id/name/members` unchanged.
  current_user: CurrentUserSchema.nullable(),
  // Ownership flags — gate vehicle/property/mortgage rules. Default false keeps
  // existing rows without these columns from producing spurious recs.
  owns_vehicle: z.boolean().default(false),
  owns_property: z.boolean().default(false),
  rents_home: z.boolean().default(false),
  has_mortgage: z.boolean().default(false),
})
export type Family = z.infer<typeof FamilySchema>
